<template>
  <div>
    <va-inner-loading :loading="loader" >
      <va-card class="mb-4">
        <div class="d-flex justify--space-between">
          <h1>Промо-Баннеры</h1>
          <va-button color="info" @click="openCreateModal">
            Добавить баннер
          </va-button>
        </div>

      </va-card>
      <banners-table  class="mb-4" :banners="getBanners"></banners-table>

      <va-modal
        v-model="showCreateForm"
        size="large"
        hide-default-actions
      >
        <promo-banner-create @action="hideModal"></promo-banner-create>

      </va-modal>

    </va-inner-loading>
  </div>
</template>

<script>

import { mapActions, mapState, mapGetters } from 'vuex'

import BannersTable from '../../components/banners/banners-table.vue'
import PromoBannerCreate from '../../components/banners/promo-banner-create.vue'
export default {
  components: { BannersTable, PromoBannerCreate },
  data () {
    return {
      showCreateForm: false,
    }
  },
  async created () {
    await this.fetchPromoBanners()
  },
  computed: {
    ...mapState('promoBanners', ['promo_banners']),
    ...mapGetters({
      loader: 'isLoading',
    }),
    getBanners () {
      return this.promo_banners
    },
  },
  methods: {
    ...mapActions({
      fetchPromoBanners: 'promoBanners/getPromoBanners',
    }),
    hideModal (val) {
      if (val) {
        this.showCreateForm = false
      } else {
        this.showCreateForm = false
      }
    },
    openCreateModal () {
      this.showCreateForm = !this.showCreateForm
    },
  },

}
</script>

<style>

</style>
